import React from 'react';
import s from './s.module.less';

interface Props {
    currentStep: number;
}

const STEPS = [
    { id: 1, title: 'Set up services' },
    { id: 2, title: 'Configure availability' },
    { id: 3, title: 'Enrich marketing profile' },
];

const StepProgressBar: React.FC<Props> = ({ currentStep }) => {
    return (
        <div className={s.container}>
            {STEPS.map((step, index) => (
                <React.Fragment key={step.id}>
                    <div className={s.stepItem}>
                        <div className={s.circleWrap}>
                            <div className={`${s.circle} ${step.id === currentStep ? s.active : s.inactive}`}>
                                <span className={`${s.number} ${step.id === currentStep ? s.activeNumber : s.inactiveNumber}`}>
                                    {step.id}
                                </span>
                            </div>
                        </div>
                        <span className={`${s.label} ${step.id === currentStep ? s.activeLabel : s.inactiveLabel}`}>
                            {step.title}
                        </span>
                    </div>
                    {index < STEPS.length - 1 && <div className={s.line} />}
                </React.Fragment>
            ))}
        </div>
    );
};

export default StepProgressBar;
